import { render } from "./recovery-usb.md?vue&type=template&id=7ed5e5f6"
import script from "./recovery-usb.md?vue&type=script&lang=js"
export * from "./recovery-usb.md?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__